import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NavigationHierarchyService } from "@common/route/navigation-hierarchy.service";
import { INavigationNode } from "@common/route/navigation-node.interface";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { OwnerHierarchyNavigationService } from "app/platform/navigation/owner-hierarchy-navigation.service";
import { Observable } from "rxjs";

@Component({
    selector: "adapt-owner-tab-content",
    templateUrl: "./owner-tab-content.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class OwnerTabContentComponent extends BaseComponent {
    public ownersHierarchy$: Observable<INavigationNode | undefined>;

    public constructor(
        navHierarchyService: NavigationHierarchyService,
    ) {
        super();
        this.ownersHierarchy$ = navHierarchyService.hierarchyChanged(OwnerHierarchyNavigationService.HierarchyId);
    }
}
